import { ColDef } from '@ag-grid-community/core';

import { formatNumber } from '@util/general/grid.util';

export const defaultColDef = {
  editable: false,
  resizable: true,
  sortable: true,
  filter: 'agTextColumnFilter',
  filterParams: {
    buttons: ['apply', 'reset'],
  },
};

export const columnDefs: ColDef[] = [
  { headerName: 'Lot Number', field: 'lotnumber', cellStyle: { textAlign: 'center' } },
  { headerName: 'UOM', field: 'uom', cellStyle: { textAlign: 'center' } },
  {
    headerName: 'Quantity',
    field: 'quantity',
    valueFormatter: (params: any) => formatNumber(params.value),
    type: 'numericColumn',
    cellStyle: { textAlign: 'center' },
  },
  { headerName: 'Status', field: 'statusabbrev', cellStyle: { textAlign: 'center' } },
  { headerName: 'Inventory Status', field: 'invstatusabbrev', cellStyle: { textAlign: 'center' } },
  {
    headerName: 'Inventory Class',
    field: 'inventoryclassabbrev',
    cellStyle: { textAlign: 'center' },
  },
  { headerName: 'Total Weight LBs', field: 'totalweight', cellStyle: { textAlign: 'center' } },
  { headerName: 'Total Weight KGs', field: 'totalweight_kgs', cellStyle: { textAlign: 'center' } },
  {
    headerName: 'Hazardous',
    field: 'hazardous',
    valueFormatter: (params: any) => (Number(params.value) ? 'Y' : 'N'),
    cellStyle: { textAlign: 'center' },
  },
  { headerName: 'Lip Count', field: 'lipcount', cellStyle: { textAlign: 'center' } },
];

export const defColumnPreferences = [
  { colId: 'lotnumber', hide: false, aggFunc: null, width: 195, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'uom', hide: false, aggFunc: null, width: 195, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'quantity', hide: false, aggFunc: null, width: 250, pivotIndex: null, pinned: null, rowGroupIndex: null },
  {
    colId: 'statusabbrev',
    hide: false,
    aggFunc: null,
    width: 200,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'invstatusabbrev',
    hide: false,
    aggFunc: null,
    width: 150,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  {
    colId: 'inventoryclassabbrev',
    hide: false,
    aggFunc: null,
    width: 165,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  { colId: 'totalweight', hide: false, aggFunc: null, width: 150, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'totalweight_kgs', hide: false, aggFunc: null, width: 150, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'hazardous', hide: false, aggFunc: null, width: 150, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'lipcount', hide: false, aggFunc: null, width: 150, pivotIndex: null, pinned: null, rowGroupIndex: null },
];
